import { RootState } from 'redux/schemas';

// eslint-disable-next-line import/prefer-default-export
export const isConfirmationDialogShown = (state: RootState) => state.app.confirmationDialog?.isShown;
